import { render, staticRenderFns } from "./InventoryProductsCard.vue?vue&type=template&id=76503df1&"
import script from "./InventoryProductsCard.vue?vue&type=script&lang=js&"
export * from "./InventoryProductsCard.vue?vue&type=script&lang=js&"
import style0 from "./InventoryProductsCard.vue?vue&type=style&index=0&id=76503df1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports